<template>
    <v-row class="basic-info__top-info py-2 px-4" no-gutters>
        <v-col
                cols="12"
                md="4"
                class="d-flex  pl-md-2 text-size text-start d-flex align-center"
        >
            <v-icon color="white" size="18" top class="mr-2">mdi-hand-coin</v-icon>
            <span class="text--gray mr-1">Crédito:</span> <span class="valor-bem">{{ (valorBem * quantidadeCotas) | moneyFormatted }}</span>
        </v-col>
        <v-col
                cols="12"
                md="4"
                class="d-flex justify-start justify-md-center mt-2 mt-md-0 text-size d-flex align-center"
        >
            <v-icon color="white" size="18" left class="mr-2">mdi-account-tie</v-icon>
            <span class="text--gray mr-1">Comissionado: </span> {{ getComissionado(cdComissionado, nmComissionado) }}
        </v-col>
        <v-col
                cols="12"
                md="4"
                class="d-flex justify-start justify-md-end pr-md-2 mt-2 mt-md-0 text-size d-flex align-center"
        >
            <v-icon color="white" size="18" left class="mr-2">mdi-office-building</v-icon>
            <span class="text--gray mr-1">PV: </span> {{ pontoVenda }}
        </v-col>
    </v-row>
</template>

  <script>
  export default {
    name: 'BasicInfoRow',
    props: {
      valorBem: {
        type: Number,
        required: false,
        default: null
      },
      cdComissionado: {
        type: String,
        required: true
      },
      nmComissionado: {
        type: String,
        required: true
      },
      cdPontoVenda: {
        type: String,
        default: ''
      },
      nmPontoVenda: {
        type: String,
        default: '-'
      },
      quantidadeCotas: {
        type: Number,
        default: 1
      }
    },
    computed: {
      pontoVenda () {
        return (this.cdPontoVenda ? this.cdPontoVenda + ' - ' : '') + this.nmPontoVenda
      }
    },
    methods: {
      getComissionado (cd_comissionado, nm_comissionado) {
        let textoComissionado = ''
        if (cd_comissionado) {
          textoComissionado += '' + cd_comissionado
        }
        if (nm_comissionado) {
          textoComissionado += ' - ' + nm_comissionado
        }
        return textoComissionado
      }
    }
  }
  </script>

  <style scoped>
    .basic-info__top-info{
    background-color: var(--primary);
    color: white;
}

 .text-size{
    font-size: 1rem;
 }
 .valor-bem{
    font-size: 1.6rem;
}
</style>
